import type { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';
import { session } from '@/helpers/auth';

export const validateAuth = (
  to: RouteLocationNormalized,
  // eslint-disable-next-line
  from: RouteLocationNormalized
): boolean | RouteLocationRaw | string | void => {
  const hasSession = session();
  const requiresAuth = to.matched.some((record) => record.meta?.requiresAuth);
  const authRoutes = [
    'log-in',
    'sign-up',
    'recover-password',
    'reset-password',
  ];

  if (requiresAuth && !hasSession) {
    return { name: 'log-in' };
  } else if (hasSession && authRoutes.includes(String(to.name))) {
    return { name: 'movements' };
  }

  return true;
};
